import ClubLeaderboard from '../../profile/ClubLeaderboard'
import {createFileRoute, useParams} from '@tanstack/react-router'

export const Route = createFileRoute('/live/leaderboard/$club_uid')({
    component: RouteComponent,
})

function RouteComponent() {
    const params = useParams({strict: false}) as any;
    return (
        <div className="bg-[#0a0e1a] min-h-screen">
            <div className="max-w-6xl mx-auto px-3 sm:px-4 py-6">
                <ClubLeaderboard clubUid={params.club_uid} live />
            </div>
        </div>
    );
}
